import { Currency } from "../utils";

export const SOCIAL_CASINO_LANG = "en_sc";
export const FREE_MODE_CURRENCY = "LSL";
export const PUBLIC_LOCATION = `${window.location.origin}/ui`;

export const EVENTS = {
  SPIN: "elysium-ui-spin",
  STOP_SPIN: "elysium-ui-stop-spin",
  PLAY_SOUND: "elysium-ui-play-sound",
  MUTE: "elysium-ui-mute-sound",
  SOUND_LEVEL: "elysium-ui-sound-level",
  UNMUTE: "elysium-ui-unmute-sound",
  STAKE_SELECTED: "elysium-stake-selected",

  // the old history events
  INIT_HISTORY: "elysium-ui-init-history",
  ADD_HISTORY_ROUND: "elysium-ui-add-history-round",

  GET_HISTORY_ROUNDS: "elysium-ui-get-history-rounds",
  GET_HISTORY_ROUND: "elysium-ui-get-history-round",

  AUTOPLAY_STARTED: "elysium-ui-autoplay-started",
  AUTOPLAY_STOPPED: "elysium-ui-autoplay-stopped",
  FREE_ROUNDS_ACCEPTED: "elysium-ui-free-rounds-accepted",
  FREE_ROUNDS_DECLINED: "elysium-ui-free-rounds-declined",
  FREE_ROUNDS_POSTPONED: "elysium-ui-free-rounds-postponed",
  QUIT_GAME: "elysium-ui-quit-game",
  TOGGLE_TURBO_SPIN: "elysium-ui-toggle-turbo-spin",
  UI_LOADED: "elysium-ui-loaded",
  HOME_BUTTON_PRESSED: "elysium-ui-home-button-pressed",
  BANK_BUTTON_PRESSED: "elysium-ui-bank-button-pressed",
  ACCOUNT_BUTTON_PRESSED: "elysium-ui-account-button-pressed",
  BUY_BONUS: "elysium-ui-buy-bonus",
  SOUND_CHOICE: "elysium-ui-sound-choice",
  OPEN_EXTERNAL_HISTORY: "elysium-ui-open-external-history",
  REALITY_CHECK_CLOSED: "elysium-ui-reality-check-closed",
};

export type InitialCfg = {
  game: { name: string };
  language: string;
  lobby: string | null;
  hasFullscreen: boolean;
  realityCheck: { time: number; start?: number; historyURL?: string } | null;
  bank?: string | null;
  accountUri?: string | null;
  hasLogo?: boolean;
};

export type InitialData = {
  stakeValues: number[];
  defaultBet: number; // this is the index for the default bet in the stake values array
  balance: {
    amount: string;
    currency: string;
    type: BalanceType;
  };
  rtp?: { value: number; level: number };
  maxWin?: number | boolean; // the boolean variant is kept for legacy reasons
  slamStop: boolean;
  currency: Currency;
  lastRound: { base?: any; freespin?: any };
  version?: string;
  autoplay: { available: boolean };
  hasTurbo?: boolean;
  hasTimer?: boolean;
  hasHistory?: boolean;
  buyFeature: boolean;
};

export type AutoplayLimit = {
  loss: {
    current: number;
    value: number;
    values: number[];
    active: boolean;
  };
  bonus: { active: boolean };
};

export type Autoplay = {
  value: number;
  active?: boolean;
  limit?: AutoplayLimit;
};

export type Button =
  | "spin"
  | "autoplay"
  | "stake"
  | "info"
  | "sound"
  | "home"
  | "bank"
  | "fullscreen"
  | "turbo"
  | "account"
  | "buyBonus";

export type FullStake = {
  value: number;
  possibleValues: number[];
  index: number;
};

export type HistoryRound = {
  loading?: boolean;
  created: string;
  roundId: string;
  bet: number;
  win: number;
  closingBalance: number;
  currencyId: string;
  currencySymbol: string;
  ts: number;
};

export type FullHistoryRound = HistoryRound & {
  // visible: boolean;
  error?: { code: number; message: string };
  sessionId: string;
  openningBalance: number;
  wins: any[];
  views: any[];
};
// export type HistoryRound = { rounds: any; next_page: number };

// "basic" is the normal case in which only the balance amount is shown, and full shows the net balance as well
export type BalanceType = "basic" | "full";
export type FreeRoundsData = {
  amount: number;
  stake: number;
  totalWin: number;
};

// 0 - is the default max win is shown normally,
// 1 - max win /together with the odds/ is also shown in the UI /Germany/,
// 2 - no max win info is shown at all /Brazil/
export enum MaxWin {
  Normal = 0,
  Germany = 1,
  Brazil = 2,
}
